var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdficon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.419,
    height: 18.609,
    viewBox: "0 0 15.419 18.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pdf_icon",
    "data-name": "Pdf icon",
    transform: "translate(35.059 -95.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g899",
    transform: "translate(-35.059 95.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g876",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M2.526,18.609A2.529,2.529,0,0,1,0,16.082V2.527A2.529,2.529,0,0,1,2.526,0h7.8A2.782,2.782,0,0,1,11.37.21a2.827,2.827,0,0,1,.768.5l.015.015,2.611,2.562a2.58,2.58,0,0,1,.472.7,2.234,2.234,0,0,1,.18.977V16.082a2.529,2.529,0,0,1-2.526,2.527Z",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2684",
    d: "M-49.247,187.119h7.608a1.614,1.614,0,0,1,.526.1,1.443,1.443,0,0,1,.367.233h0l2.509,2.473a1.391,1.391,0,0,1,.224.325,1.24,1.24,0,0,1,.063.377s0,.008,0,.012V201.6a1.153,1.153,0,0,1-1.159,1.165H-49.247a1.153,1.153,0,0,1-1.159-1.165V188.283a1.153,1.153,0,0,1,1.159-1.165Z",
    transform: "translate(51.886 -185.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2697",
    d: "M-35.4,209.408c-.352-.44.029-1.045,1.063-1.688l.651-.4.254-.693c.139-.381.348-1,.463-1.383l.209-.689-.144-.51a4.513,4.513,0,0,1-.128-1.909c.152-.459.651-.412.848.08a3.849,3.849,0,0,1-.044,1.958l-.15.72.132.28c.073.154.285.519.471.812l.351.545.436-.071c1.386-.226,1.86.158,1.86.709,0,.695-1.088.752-2-.05a3.05,3.05,0,0,1-.347-.36s-.572.146-.854.24-.436.159-.862.339c0,0-.149.271-.247.469a4.858,4.858,0,0,1-1.088,1.563C-34.869,209.615-35.223,209.632-35.4,209.408Zm.553-.247a5.069,5.069,0,0,0,.876-1.3l.112-.223-.512.321c-.79.5-1.151.964-.964,1.247C-35.23,209.371-35.1,209.358-34.849,209.162Zm5.132-1.8a.419.419,0,0,0-.053-.649c-.17-.107-.308-.129-.75-.121a7.816,7.816,0,0,0-.784.113s.24.208.347.284a4.17,4.17,0,0,0,.739.386c.249.1.392.085.5-.012Zm-2.063-1.072a6.351,6.351,0,0,1-.443-.714,4.189,4.189,0,0,1-.248-.462s-.121.486-.22.778l-.309.955-.09.217s.477-.2.719-.274.778-.212.778-.212Zm-.665-3.332a1.731,1.731,0,0,0-.038-.785c-.224-.305-.494-.051-.448.676a6.087,6.087,0,0,0,.129.919l.118.468.083-.352C-32.556,203.69-32.486,203.273-32.446,202.958Z",
    transform: "translate(40.039 -198.015)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g858",
    transform: "translate(4.619 12.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path845",
    d: "M-31.067,249.125h.715a1.943,1.943,0,0,1,.556.066.653.653,0,0,1,.359.285.938.938,0,0,1,.146.531.965.965,0,0,1-.118.491.7.7,0,0,1-.319.3,1.556,1.556,0,0,1-.613.091h-.247v1.127h-.478Zm.478.37V250.5h.237a.623.623,0,0,0,.438-.118.517.517,0,0,0,.123-.385.578.578,0,0,0-.08-.321.329.329,0,0,0-.178-.152,1.111,1.111,0,0,0-.3-.03Z",
    transform: "translate(31.067 -249.125)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path847",
    d: "M-20.547,249.125h.649a1.468,1.468,0,0,1,.753.167,1.039,1.039,0,0,1,.427.5,1.789,1.789,0,0,1,.146.732,2.042,2.042,0,0,1-.131.755,1.2,1.2,0,0,1-.4.533,1.236,1.236,0,0,1-.761.2h-.685Zm.478.383v2.121h.2a.669.669,0,0,0,.6-.288,1.4,1.4,0,0,0,.188-.772q0-1.061-.793-1.062Z",
    transform: "translate(22.689 -249.125)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path849",
    d: "M-8.593,249.125h1.6v.383H-8.115v.863h.9v.383h-.9v1.258h-.478Z",
    transform: "translate(13.168 -249.125)",
    fill: "#00246a"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdficon);
export default __webpack_public_path__ + "static/media/Pdf icon.7fe0d864dbd1c13f7d27f1ad0ba817f7.svg";
export { ForwardRef as ReactComponent };